// export const PROTOCOL_CHAIN_ID = "5";
// export const PROTOCOL_PUBLIC_RPC = "https://goerli.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161";
export const PROTOCOL_CHAIN_ID = "137";
export const PROTOCOL_PUBLIC_RPC =
  "https://polygon-mainnet.infura.io/v3/8a99b35afb184e9488eaf0f5037b48d1";
export const TX_SERVICE_URL = "https://safe-transaction-polygon.safe.global";
export const REVIEW_TABLE_ID = "reviews_137_135";
export const ZERO_ADDRESS = "0x0000000000000000000000000000000000000000";
export const STARTING_BLOCK = 49018523;
